import { render, staticRenderFns } from "./FarmCard.vue?vue&type=template&id=7fb1cade&scoped=true&"
import script from "./FarmCard.vue?vue&type=script&lang=js&"
export * from "./FarmCard.vue?vue&type=script&lang=js&"
import style0 from "./FarmCard.vue?vue&type=style&index=0&id=7fb1cade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb1cade",
  null
  
)

export default component.exports